import type { ValidationConfig } from '../validationEngine/types';

/**
 * A deal or quote can be created and saved without a selling vehicle (Quick Quote, SCI no-payment), but
 * every action that hands the deal to a downstream system breaks there - Shopper platform (AMD/Customer
 * View), DMS, F&I and contracting all assume a vehicle.
 *
 * `CUSTOM` rather than `REQUIRED` because the value is a boolean: `false` is a legitimate value, not an
 * empty one, and REQUIRED only fires on null/undefined/''.
 *
 * A vehicle-less deal only exists once Quick Quote mode is on, so the rule rides that toggle.
 */
export const sellingVehicleValidationConfig: ValidationConfig = {
    hasVehicle: {
        rules: [
            {
                type: 'CUSTOM',
                flow: 'save',
                params: { evaluator: (value: unknown) => value === true },
                conditions: { enabledToggles: 'FEAT278181_MV_Quick_Quote_Mode' },
                messages: 'A vehicle is required to continue.'
            }
        ]
    }
};
